import React from 'react';
import styled from 'styled-components';

import { AuthState, withAuth } from 'context/auth';
import { withAlerts, AlertsState } from 'context/alerts';
import {
  Button,
  Jumbotron,
  PageLoader,
} from 'components';

const StyledDarkContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${p => p.theme.colors.deepGreyTransparent};
  padding: 30px 50px;
  border: 1px solid ${p => p.theme.colors.grey};
  max-width: 700px;
  min-width: 600px;

  h3 {
    font-size: ${p => p.theme.fontSize['2xl']};
    margin-bottom: 42px;
  }

  > p {
    margin-top: 0;
    font-size: ${p => p.theme.fontSize.lg};
    text-align: center;
  }
`;
const StyledDarkContainerHeader = styled.h3`
  margin-top: 0;
`;
const StyledDescription = styled.p`
  text-align: center;
  margin-top: 0;
  margin-bottom: 20px;
  font-size: ${p => p.theme.fontSize.xl};
  max-width: 440px;
`;

interface Props {
  auth: AuthState;
  alerts: AlertsState;
}

const ExamNotValidPage = (props: Props) => {
  const renderTermsModal = () => {
    return (
      <div>
        <p>
          Contact us,{' '}
          <a href="mailto:genesandhealth@qmul.ac.uk">
            genesandhealth@qmul.ac.uk
          </a>
        </p>
      </div>
    );
  };

  const renderLowerHalf = () => {
    const auth = props.auth;
    return (
      <>
        <StyledDarkContainer id="dark-container">
          <StyledDarkContainerHeader>
            Hello GenesAndHealth user!
          </StyledDarkContainerHeader>
          <StyledDescription>
            To proceed to the Sandbox, you’re required to take a data security
            exam in our Tutorial Site. Watch data security videos, answer the
            questions and navigate back to this site when you have passed the
            exam.
          </StyledDescription>
          <StyledDescription>
            If you are logging in for the first time and have completed the
            exam, please revisit the tutorial site and come back. This will send
            your exam result to the Sandbox, and you will be able to log in.
            Sorry for the inconvenience!
          </StyledDescription>
          <Button
            type="button"
            disabled={auth.trainingSiteURL === ''}
            onClick={() => {
              window.location.href = auth.trainingSiteURL;
            }}
          >
            Continue to Tutorial Site
          </Button>
          {renderTermsModal()}
        </StyledDarkContainer>
      </>
    );
  };

  const renderUpperHalf = () => {
    return <></>;
  };

  // show loader while we fetch the security info
  if (props.auth.trainingSiteURL === '') {
    const imageExamNotValid = require(
      `images/${process.env.REACT_APP_BACKGROUND_IMAGE}`
    );
    return (
      <PageLoader
        hideLoader={props.alerts.message}
        loaderBackground={imageExamNotValid}
      />
    );
  }

  return (
    <>
      <Jumbotron upperHalf={renderUpperHalf()} lowerHalf={renderLowerHalf()} />
    </>
  );
};
export default withAuth(withAlerts(ExamNotValidPage));
